import React, { useCallback, SyntheticEvent } from "react";

import CardMedia from "@mui/material/CardMedia";

import { prepareTextAttribute } from "~/helpers/prepare-text-attribute";

import { ProductImageProps, Proportions } from "./types";

export const ProductImage: React.FC<ProductImageProps> = ({
  width,
  proportions = Proportions.p1to1,
  src,
  alt,
  className,
  title,
}) => {
  const handleError = useCallback(
    (event: SyntheticEvent<HTMLImageElement>): void => {
      event.currentTarget.src = "/assets/images/no-image.png";
    },
    [],
  );

  return (
    <CardMedia
      style={{
        maxWidth: width,
        aspectRatio: `${proportions}`,
      }}
      className={className}
      onError={handleError}
      component="img"
      src={src}
      alt={prepareTextAttribute(alt, true)}
      title={prepareTextAttribute(title ?? alt)}
    />
  );
};
